module.exports = __webpack_public_path__ + "img/02-Eisai-เช็คหมอง.3be80e09.png";